import React from 'react';
import TableFilterInput from '../../../../components/table/TableFilterInput';
import OpenUserDetail from '../../../../components/link/OpenUserDetail';
import Anchor from '../../../../components/link/Anchor';
import {
  openNewWindow,
  setColumnWidth,
  setDash,
  setDetailPageUrl,
  setPhoneFormat,
  setNumberWithComma,
} from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import OpenOrderItemDetail from '../../../../components/link/OpenOrderItemDetail';
import OpenBrandDetail from '../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../components/link/OpenProductDetail';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { ACCOUNT_USER_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';

/**
 *  쿠폰 사용 내역 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, onFilter, getProductSubCategoryList } = data;
  return [
    {
      accessor: 'couponGeneratedId',
      Header: '쿠폰 발급 ID',
      fixed: 'left',
    },
    {
      accessor: 'userId',
      Header: '유저 ID',
      fixed: 'left',
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(ACCOUNT_USER_DETAIL_URL_PATH, row.value))}
        />
      ),
    },
    {
      accessor: 'userName',
      Header: '이름',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'userName'),
      Cell: (row) => setDash(row.value),
      Filter: () => <TableFilterInput option={filterOption.userName} onFilter={(userName) => onFilter({ userName })} />,
    },
    {
      accessor: 'userAccount',
      Header: '아이디',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'userAccount'),
      Cell: (row) => <OpenUserDetail text={row.value} userId={row.original.userId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.userAccount} onFilter={(userAccount) => onFilter({ userAccount })} />
      ),
    },
    {
      accessor: 'userCellPhone',
      Header: '휴대폰 번호',
      width: 160,
      Cell: (row) => <OpenUserDetail text={setPhoneFormat(row.value)} userId={row.original.userId} />,
    },
    {
      accessor: 'createDate',
      Header: '발급일시',
      width: 160,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      accessor: 'useDate',
      Header: '사용일시',
      width: 160,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      accessor: 'orderItemId',
      Header: '상품 주문번호',
      filterable: true,
      width: 150,
      Cell: (row) => <OpenOrderItemDetail text={row.value} orderItemId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.orderItemId} onFilter={(orderItemId) => onFilter({ orderItemId })} />
      ),
    },
    {
      accessor: 'brandName',
      Header: '브랜드명',
      width: setColumnWidth(list, 'brandName'),
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.brandId} />,
    },
    {
      accessor: 'brandId',
      Header: '브랜드 ID',
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
    },
    {
      accessor: 'productName',
      Header: '상품명',
      width: setColumnWidth(list, 'productName'),
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.original.productId} />,
    },
    {
      accessor: 'productId',
      Header: '상품 ID',
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
    },
    {
      accessor: 'mainCategory',
      Header: '1차 카테고리',
      width: setColumnWidth(list, 'mainCategory') + 40,
    },
    {
      accessor: 'isSubCategoryExists',
      Header: '2차 카테고리',
      width: 120,
      Cell: (row) =>
        row.value ? (
          <Anchor
            text="카테고리 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              getProductSubCategoryList({
                productId: row.original.productId,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      accessor: 'orderPrice',
      Header: '총 주문금액',
      width: 160,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'quantity',
      Header: '수량',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'usedPoint',
      Header: '포인트 할인 금액',
      width: 160,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'usedCouponPrice',
      Header: '쿠폰 할인 금액',
      width: 160,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'totalPrice',
      Header: '실제 결제 금액',
      width: 160,
      Cell: (row) => setNumberWithComma(row.value),
    },
  ];
};

export default columns;
